import { render, staticRenderFns } from "./CustomRoomsComponent.vue?vue&type=template&id=de224212&"
import script from "./CustomRoomsComponent.vue?vue&type=script&lang=js&"
export * from "./CustomRoomsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports